/* @generated from adl module FileTreeView */

import * as ADL from './runtime/adl';
import * as HexgripError from './HexgripError';

export interface FileTreeView_Entries {
  kind: 'entries';
  value: Entry[];
}
export interface FileTreeView_Error {
  kind: 'error';
  value: HexgripError.HexgripError;
}

export type FileTreeView = FileTreeView_Entries | FileTreeView_Error;

export interface FileTreeViewOpts {
  entries: Entry[];
  error: HexgripError.HexgripError;
}

export function makeFileTreeView<K extends keyof FileTreeViewOpts>(kind: K, value: FileTreeViewOpts[K]) { return {kind, value}; }

const FileTreeView_AST : ADL.ScopedDecl =
  {"moduleName":"FileTreeView","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"entries","default":{"kind":"nothing"},"name":"entries","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"FileTreeView","name":"Entry"}},"parameters":[]}]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"HexgripError","name":"HexgripError"}},"parameters":[]}}]}},"name":"FileTreeView","version":{"kind":"nothing"}}};

export const snFileTreeView: ADL.ScopedName = {moduleName:"FileTreeView", name:"FileTreeView"};

export function texprFileTreeView(): ADL.ATypeExpr<FileTreeView> {
  return {value : {typeRef : {kind: "reference", value : snFileTreeView}, parameters : []}};
}

export interface Entry_File {
  kind: 'file';
  value: FileEntry;
}
export interface Entry_Directory {
  kind: 'directory';
  value: DirectoryEntry;
}
export interface Entry_FailedDirectory {
  kind: 'failedDirectory';
  value: FailedDirectoryEntry;
}

export type Entry = Entry_File | Entry_Directory | Entry_FailedDirectory;

export interface EntryOpts {
  file: FileEntry;
  directory: DirectoryEntry;
  failedDirectory: FailedDirectoryEntry;
}

export function makeEntry<K extends keyof EntryOpts>(kind: K, value: EntryOpts[K]) { return {kind, value}; }

const Entry_AST : ADL.ScopedDecl =
  {"moduleName":"FileTreeView","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"file","default":{"kind":"nothing"},"name":"file","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"FileTreeView","name":"FileEntry"}},"parameters":[]}},{"annotations":[],"serializedName":"directory","default":{"kind":"nothing"},"name":"directory","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"FileTreeView","name":"DirectoryEntry"}},"parameters":[]}},{"annotations":[],"serializedName":"failedDirectory","default":{"kind":"nothing"},"name":"failedDirectory","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"FileTreeView","name":"FailedDirectoryEntry"}},"parameters":[]}}]}},"name":"Entry","version":{"kind":"nothing"}}};

export const snEntry: ADL.ScopedName = {moduleName:"FileTreeView", name:"Entry"};

export function texprEntry(): ADL.ATypeExpr<Entry> {
  return {value : {typeRef : {kind: "reference", value : snEntry}, parameters : []}};
}

export interface FileEntry {
  name: string;
}

export function makeFileEntry(
  input: {
    name: string,
  }
): FileEntry {
  return {
    name: input.name,
  };
}

const FileEntry_AST : ADL.ScopedDecl =
  {"moduleName":"FileTreeView","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"FileEntry","version":{"kind":"nothing"}}};

export const snFileEntry: ADL.ScopedName = {moduleName:"FileTreeView", name:"FileEntry"};

export function texprFileEntry(): ADL.ATypeExpr<FileEntry> {
  return {value : {typeRef : {kind: "reference", value : snFileEntry}, parameters : []}};
}

export interface DirectoryEntry {
  name: string;
  children: Entry[];
}

export function makeDirectoryEntry(
  input: {
    name: string,
    children: Entry[],
  }
): DirectoryEntry {
  return {
    name: input.name,
    children: input.children,
  };
}

const DirectoryEntry_AST : ADL.ScopedDecl =
  {"moduleName":"FileTreeView","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"children","default":{"kind":"nothing"},"name":"children","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"FileTreeView","name":"Entry"}},"parameters":[]}]}}]}},"name":"DirectoryEntry","version":{"kind":"nothing"}}};

export const snDirectoryEntry: ADL.ScopedName = {moduleName:"FileTreeView", name:"DirectoryEntry"};

export function texprDirectoryEntry(): ADL.ATypeExpr<DirectoryEntry> {
  return {value : {typeRef : {kind: "reference", value : snDirectoryEntry}, parameters : []}};
}

export interface FailedDirectoryEntry {
  name: string;
  error: HexgripError.HexgripError;
}

export function makeFailedDirectoryEntry(
  input: {
    name: string,
    error: HexgripError.HexgripError,
  }
): FailedDirectoryEntry {
  return {
    name: input.name,
    error: input.error,
  };
}

const FailedDirectoryEntry_AST : ADL.ScopedDecl =
  {"moduleName":"FileTreeView","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"HexgripError","name":"HexgripError"}},"parameters":[]}}]}},"name":"FailedDirectoryEntry","version":{"kind":"nothing"}}};

export const snFailedDirectoryEntry: ADL.ScopedName = {moduleName:"FileTreeView", name:"FailedDirectoryEntry"};

export function texprFailedDirectoryEntry(): ADL.ATypeExpr<FailedDirectoryEntry> {
  return {value : {typeRef : {kind: "reference", value : snFailedDirectoryEntry}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "FileTreeView.FileTreeView" : FileTreeView_AST,
  "FileTreeView.Entry" : Entry_AST,
  "FileTreeView.FileEntry" : FileEntry_AST,
  "FileTreeView.DirectoryEntry" : DirectoryEntry_AST,
  "FileTreeView.FailedDirectoryEntry" : FailedDirectoryEntry_AST
};
